/**
 * Returns array indices sorted by position ascending (index of smallest position first).
 */
export function getOrderIndices(positions) {
  return [...Array(positions.length).keys()].sort((a, b) => positions[a] - positions[b]);
}
